/**
 * Firestore may store companyId as a string or (legacy) DocumentReference.
 * Storage rules compare against the string id in the object path — normalize here
 * so the path always matches `users/{uid}.companyId` in rules.
 */
export function normalizeCompanyIdForStorage(raw) {
  if (raw == null || raw === '') return '';
  if (typeof raw === 'string') return raw.trim();
  if (typeof raw === 'object' && typeof raw.id === 'string') return raw.id.trim();
  const s = String(raw).trim();
  return s;
}

/** Firebase Storage object path for the company branding logo (single file). */
export function companyBrandingLogoStoragePath(companyId) {
  const id = normalizeCompanyIdForStorage(companyId);
  if (!id) return '';
  return `company_branding/${id}/branding_logo`;
}

export const COMPANY_BRANDING_LOGO_MAX_BYTES = 2 * 1024 * 1024;

/** Accept attribute for file input */
export const COMPANY_BRANDING_LOGO_ACCEPT = 'image/png,image/jpeg,image/jpg,image/webp,image/gif';

const ALLOWED_MIME = new Set(['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif']);

export function isAllowedBrandingLogoFile(file) {
  if (!file || typeof file.type !== 'string') return false;
  return ALLOWED_MIME.has(file.type.toLowerCase()) || /^image\/(png|jpeg|jpg|webp|gif)$/i.test(file.type);
}
